import { initChain } from "./utils/MetamaskHelper";

initChain();
